import * as C from '../../actionTypes/caterings/new'

export const submit = (payload) => ({type: C.SUBMIT, payload})
